'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Common = void 0;
var $ = require("jquery");
var Common = /** @class */ (function () {
    function Common() {
        var _this = this;
        var self = this;
        $('a[href^="#"]').click(function () {
            var href = $(this).attr("href");
            if (self.isAnchor(href)) {
                self.scrollToAnchor(href);
                return false;
            }
        });
        // URLがアンカーリンク付きだった時
        // window.addEventListener('load', () => {
        $(window).on('load', function () {
            var url = location.href;
            if (_this.isAnchor(url)) {
                $("html, body").animate({ scrollTop: 0 }, 0, 'linear');
                setTimeout(function () {
                    self.scrollToAnchor(url);
                }, 300);
                return false;
            }
        });
    }
    Common.prototype.isAnchor = function (href) {
        return href.indexOf('#') != -1;
    };
    Common.prototype.getAnchorName = function (href) {
        var index = href.indexOf('#');
        return href.slice(index + 1);
    };
    Common.prototype.scrollToAnchor = function (href) {
        var headerHeight = $('.paramHeader').outerHeight() || 0;
        var anchor = this.getAnchorName(href);
        var position = $('#' + anchor).offset().top - headerHeight;
        $("html, body").animate({ scrollTop: position }, 400, 'linear');
    };
    return Common;
}());
exports.Common = Common;
exports.default = Common;
